import { useEffect } from 'react';

import { FirebaseService } from '@flexo/general';
import { useDispatch, useSelector } from 'react-redux';
import { KPI, USER, ALERT } from '@flexo/reducers';
import { useLocation, useParams } from 'react-router-dom';

const firebaseService = new FirebaseService();

export const EnergyMemberRankingResolver = () => {

  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const metadata = useSelector((state: any) => state.metadata);
  const calendar = useSelector((state: any) => state.calendar);
  const pathSegment = location.pathname.split('/')[1]; 

  const { hiveCalendar } = calendar;
  const { selectedDate, selectedTimeSet } = hiveCalendar;

  async function init() {

    if (!location.pathname.includes('member')) { return; }

    const MEMBER_ID = params?.id || metadata?.selectedEntity?.memberId || null;

    if (!MEMBER_ID) { return; }

    const idToken = await firebaseService.getIdToken();

    if (!idToken) {
      dispatch(ALERT.SetAlert({
        value: {
          type: 'BANNER_SESSION_EXPIRED'
        },
      } as any));
      
      // setUserStore({
      //   type: UserTypes.SetUserLogOut,
      //   payload: {
      //     value: true,
      //   }
      // })

      dispatch(USER.SetLogout());

      return;
    }

    dispatch(KPI.SetEnergyKpiDataMemberRankingAsync({MEMBER_ID, idToken, selectedDate, selectedTimeSet}) as any);
  }

  useEffect(() => {
      init();
  }, []);

  useEffect(() => {
      init();
  }, [selectedDate, params?.id, pathSegment]);

  return <></>;
};
